import React, { useEffect, useContext ,useState,useCallback,} from 'react';
import { Button, Col, Pagination, Row, Space, Table,Card,List,Typography,Input,Image  } from "antd";
import NotFound from "../../../../components/common/notFound";
import { SearchFutureCustomerPersonaContext } from '../searchContext';
import { useLocation, useNavigate } from "react-router-dom";
import {
    DATA_MASTER_DATA_TYPE,
    INDUSTRY,
    INDUSTRY_TYPE,
    REGION_GROUP,
    SUCCESS_CODE,
    WORK_PERIOD,
    COMPANY_TYPE,
    VOC_MASTER_DATA_TYPE,
    PRODUCT_REQUIREMENT,
    OTHER_PRODUCT_EXPECT,
    SUPPORT_REQUIREMENT,
    CUSTOMER_SUPPORT,
    OTHER_SUPPORT_EXPECT,
    BUSINESS_REQUIRE,
    OTHER_BUSINESS_EXPECT,
    CUSTOMER_EXPECT,
    CURRENT_CUSTOMER_INDUSTRY_TYPE,
  } from "../../../../lib/const";
import{
getFutureCustomer,
searchFutureCustomer,
getDropDownMaster,
getDropDownVOC,

} from "../../../../services/customerFutures";
import { vocDataFuture } from "../../../customer/touchpoint/components/dataReport";
import { downloadFile } from "../../../../services/uploadFile";
import { message, Modal } from 'antd';
import useCountry from "../../../../lib/hooks/useCountry";
import moment from "moment";
import "../stlye.css"
import Logo from "../../../../assets/images/ieat_logo.png";
const { Text } = Typography;
const Content = ({ roleUser }) => {
    const {
        searchValues,
        setSearchValues,
        pageValues,
        setPageValues,
        search,
        setSearch,
        setFutureCusId,
      } = useContext(SearchFutureCustomerPersonaContext)
    
    const [previewImage, setPreviewImage] = useState(null);
    const location = useLocation();
    const [dataSource, setDataSource] = useState([]);
    let [no, setNo] = useState(0);
    const [countries] = useCountry();

    const [dataDetail, setDataDetail] = useState([]);
    const [dropDownCurerntStatus, setDropDownCurerntStatus] = useState([]);

    const [dropDownMaster, setDropDownMaster] = useState([]);
    const [dropDownCompanyType, setDropDownCompanyType] = useState([]);
    const [dropDownIndustryType, setDropDownIndustryType] = useState([]);
    const [dropDownAreaType, setDropDownAreaType] = useState([]);
    const [dropDownKnowChannel, setDropDownKnowChannel] = useState([]);
    const [dropDownRegionGroup, setDropDownRegionGroup] = useState([]);
    const [dropDownPurpost, setDropDownPurpost] = useState([]);
    const [futureCustomerContacts, setFutureCustomerContacts] = useState([]);

    const [dropDownVOC, setDropDownVOC] = useState([]);
    const [dropDownproductRequirement, setDropDownProductRequirement] = useState(
        []
      );
      const [dropDowncustomerSupport, setDropDownCustomerSupport] = useState([]);
      const [dropDowncustomerExpact, setDropDownCustomerExpact] = useState([]);
      const [dropDownbusinessRequire, setDropDownbusinessRequire] = useState([]);
      const [dropDownotherProductExpect, setDropDownotherProductExpect] = useState(
        []
      );
      const [dropDownotherSupportExpect, setDropDownSupportExpect] = useState([]);
      const [dropDownotherBusinessExpect, setDropDownBusinessExpect] = useState([]);
    
      const [productRequirement, setProductRequirement] = useState({});
      const [customerSupport, setCustomerSupport] = useState({});
      const [customerExpact, setCustomerExpact] = useState({});
      const [businessRequire, setbusinessRequire] = useState({});
      const [otherProductExpect, setotherProductExpect] = useState({});
      const [otherSupportExpect, setotherSupportExpect] = useState({});
      const [otherBusinessExpect, setotherBusinessExpect] = useState({});
      const [otherExpect, setotherExpect] = useState({});

    const [countMonth, setCounthMonth] = useState(0);
    const [previewImageH,setPreviewImageH] = useState();
    const [previewPdfH,setPreviewPdfH] = useState();
    const CalMonth = (dateString) => {
        const d_now = new Date();
        const getDate = (date) => moment(date, "DD/MM/YYYY").startOf("month");
        const diff = Math.abs(getDate(dateString).diff(getDate(d_now), "months"));

        return diff;
    };
    
    const getDetail = useCallback(
    async (searchValues, pageValues) => {
      const res = await searchFutureCustomer(searchValues, pageValues);
        var { objectValue, pageValue } = res.data;
        const res_detail = await getFutureCustomer(objectValue[0].futureCustomerId);
        try{
        const getImage = await downloadFile(res_detail.data.objectValue.pathName);
        const { objectValue } = getImage.data;
        if (objectValue?.bytes) {
           let type = objectValue.headers["Content-Type"]?.[0] || 'content-type' ;
            if (type === "application/octet-stream") {
                if (objectValue.fileName.toLowerCase().endsWith(".pdf")) {
                    type = "application/pdf";
                    const base64Src = `data:${type};base64,${objectValue.bytes}`;
                    setPreviewPdfH(base64Src);
                }}else{
                    const base64Src = `data:${type};base64,${objectValue.bytes}`;
                    setPreviewImageH(base64Src);
                }
        } else {
            message.error("ไม่สามารถแสดงภาพได้");
            setPreviewImageH(null);
            setPreviewPdfH(null);

        }
        } catch (err) {
        console.error("Download error", err);
        message.error("เกิดข้อผิดพลาดในการโหลดภาพ");
        }
        // const res_detail = await getFutureCustomer(objectValue[0].futureCustomerId);
        objectValue[0].obJectFuture = res_detail.data.objectValue;
        if (res.data.code === "0000") {
        let result_data = res_detail.data.objectValue;
        setDataDetail(result_data);
        setCounthMonth(CalMonth(result_data.fromDate));
        // console.log('objectValue : ',objectValue)
        // console.log('res_detail : ',res_detail)
        // console.log('date:',res_detail.fromDate)
        setFutureCustomerContacts(result_data.futureCustomerContacts);

        const product_requirement = result_data.futureCustomerVoc.filter(
            (word) => word.type === "product_requirement"
        );
        setProductRequirement(
            product_requirement.length > 0 ? product_requirement[0].detail : ""
        );

        const customer_support = result_data.futureCustomerVoc.filter(
            (word) => word.type === "customer_support"
        );
        setCustomerSupport(
            customer_support.length > 0 ? customer_support[0].detail : ""
        );

        const business_require = result_data.futureCustomerVoc.filter(
            (word) => word.type === "business_require"
        );
        setbusinessRequire(
            business_require.length > 0 ? business_require[0].detail : ""
        );

        const customer_expect = result_data.futureCustomerVoc.filter(
            (word) => word.type === "customer_expect"
        );
        setCustomerExpact(
            customer_expect.length > 0 ? customer_expect[0].detail : ""
        );

        const other_product_expect = result_data.futureCustomerVoc.filter(
            (word) => word.type === "other_product_expect"
        );
        setotherProductExpect(
            other_product_expect.length > 0 ? other_product_expect[0].detail : ""
        );

        const other_support_expect = result_data.futureCustomerVoc.filter(
            (word) => word.type === "other_support_expect"
        );
        setotherSupportExpect(
            other_support_expect.length > 0 ? other_support_expect[0].detail : ""
        );

        const other_business_expect = result_data.futureCustomerVoc.filter(
            (word) => word.type === "other_business_expect"
        );
        setotherBusinessExpect(
            other_business_expect.length > 0 ? other_business_expect[0].detail : ""
        );

        const other_expect = result_data.futureCustomerVoc.filter(
            (word) => word.type === "other_expect"
        );
        setotherExpect(other_expect.length > 0 ? other_expect[0].detail : "");
        }
        setFutureCusId(objectValue[0].futureCustomerId);
        if (res?.data?.code === SUCCESS_CODE) {
            let _p =
                parseInt(pageValues.page) === 0
                ? parseInt(pageValues.page)
                : parseInt(pageValues.page) * pageValues.pageSize;
            setNo(_p);
            setDataSource(objectValue);
            // setSearchValues(objectValue);
            setPageValues(pageValue);
            } else {
            setDataSource([]);
            setPageValues((prev) => ({
                ...prev,
                page: 0,
                pageSize: 1,
                total: 0,
                totalPage: 0,
            }));
        }
    },
    [setDataSource, setSearchValues, setPageValues]);
    const getMaster = useCallback(
        async (toppicKey) => {
          try {
            const res = await getDropDownMaster(toppicKey);
            if (res.data.code === "0000") {
              let result_data = res.data.objectValue;
              if (toppicKey == "current_status") {
                setDropDownCurerntStatus(result_data);
              } else if (toppicKey == "company_type") {
                setDropDownCompanyType(result_data);
              } else if (toppicKey == "industry_type") {
                setDropDownIndustryType(result_data);
              } else if (toppicKey == "area_type") {
                setDropDownAreaType(result_data);
              } else if (toppicKey == "known_channel") {
                setDropDownKnowChannel(result_data);
              } else if (toppicKey == "region_group") {
                setDropDownRegionGroup(result_data);
              } else if (toppicKey == "purpose_contact") {
                setDropDownPurpost(result_data);
              }
            }
          } catch (error) {
            // console.log("error==>", error);
          }
        },
        [dropDownMaster]
    );
    const getVOC = useCallback(
        async (toppicKey) => {
            const res = await getDropDownVOC(toppicKey);
            if (res.data.code === "0000") {
            let result_data = res.data.objectValue;
    
            if (toppicKey == "product_requirement") {
                setDropDownProductRequirement(result_data);
            } else if (toppicKey == "customer_support") {
                setDropDownCustomerSupport(result_data);
            } else if (toppicKey == "business_require") {
                setDropDownbusinessRequire(result_data);
            } else if (toppicKey == "customer_expect") {
                setDropDownCustomerExpact(result_data);
            } else if (toppicKey == "other_product_expect") {
                setDropDownotherProductExpect(result_data);
            } else if (toppicKey == "other_support_expect") {
                setDropDownSupportExpect(result_data);
            } else if (toppicKey == "other_business_expect") {
                setDropDownBusinessExpect(result_data);
            }
            }
        },
        [dropDownVOC]
    );
    useEffect(() => {
        if (search) {
            getDetail(searchValues, pageValues);
            setSearch(false);

        }
    

      }, [getDetail, search]);
    useEffect(() => {
        vocDataFuture.map((item) => {
              getVOC(item);
            });

        getMaster("current_status");
        getMaster("company_type");
        getMaster("industry_type");
        getMaster("area_type");
        getMaster("known_channel");
        getMaster("region_group");
        getMaster("purpose_contact");
    },[location]);
    
    const columns = [
        {
            title: "ลำดับ",
            align: "center",
            dataIndex: "sequence",
            key: "sequence",
            width: 72,
        },
        {
            title: "ชื่อ-นามสกุล",
            align: "center",
            dataIndex: "name",
            key: "name",
            width: 72,
        },
        {
            title: "ตำแหน่ง",
            align: "center",
            dataIndex: "position",
            key: "position",
            width: 72,
        },
        {
            title: "เบอร์โทรศัพท์ผู้ติดต่อ",
            align: "center",
            dataIndex: "phones",
            key: "phones",
            width: 72,
            render: (phones) =>
            Array.isArray(phones)
                ? phones.map((phone, idx) => <div key={idx}>{phone}</div>)
                : phones ?? "-",
        },
        {
            title: "Email ผู้ติดต่อ",
            align: "center",
            dataIndex: "emails",
            key: "emails",
            width: 72,
            render: (emails) =>
                Array.isArray(emails)
                    ? emails.map((email, idx) => <div key={idx}>{email}</div>)
                    : emails ?? "-",
        },
    ];
    const onPageChange = (page, pageSize) => {
        setNo(no + pageSize);
        setSearch(true);
        setPageValues((prev) => ({
          ...prev,
          page: page - 1,
          pageSize: pageSize,
        }));
      };
    const [modalIndex, setModalIndex] = useState(null);
    const [previewPdf, setPreviewPdf] = useState(false);
    const showImage = async (filePath,index) => {
        try {
        const res = await downloadFile(filePath);
        const { objectValue } = res.data;
        if (objectValue?.bytes) {
           let type = objectValue.headers["Content-Type"]?.[0] || 'content-type' ;
            if (type === "application/octet-stream") {
                if (objectValue.fileName.toLowerCase().endsWith(".pdf")) {
                    type = "application/pdf";
                    const base64Src = `data:${type};base64,${objectValue.bytes}`;
                    setPreviewPdf(base64Src);
                    setModalIndex(index);
                }}else{
                    const base64Src = `data:${type};base64,${objectValue.bytes}`;
                    setPreviewImage(base64Src);
                    setModalIndex(index); 
                }
        } else {
            message.error("ไม่สามารถแสดงภาพได้");
        }
        } catch (err) {
        console.error("Download error", err);
        message.error("เกิดข้อผิดพลาดในการโหลดภาพ");
        }
        
    };
    
    return (
        <div style={{ marginTop: 20 }}>
            <p style={{ margin: "30px 0 10px 0", fontWeight: 500 }}>
                รายการทั้งหมด{" "}
                <span className="pr-purple" style={{ fontWeight: 700 }}>
                {pageValues.total}
                </span>{" "}
                รายการ
            </p>
            <Row gutter={[16, 16]}>
                <Col span={24}>
                    <div className="gutter-box">
                        <List
                            id={"LIST_FUTURE_CUSTOMER"}
                            locale={{ emptyText: <NotFound /> }}
                            // loading={loading}
                        
                            dataSource={dataSource}
                            
                            backgroud-color={"#ff0000"}
                            scroll={{
                            x: 1300,
                            }}
                            pagination={false}
                            renderItem={(item, index) => (
                                <List.Item 
                                id={"LIST_FUTURE_CUSTOMER_ITEM"}
                                className={"gutter-box"}
                                // actions={[<a key="list-loadmore-edit">edit</a>, <a key="list-loadmore-more">more</a>]}
                                
                                > { 
                                //console.log(item)
                                console.log('dataSource:',item)
                                
                                }
                                <Row>
                                    <Col span={4}></Col><Col span={16}><br/><div  className="text-white-head-center">Future Customer Persona (กลุ่มลูกค้าอนาคต)</div><br/><br/></Col><Col span={4}><img src={Logo} height={50} alt="I-EA-T LOGO" /></Col>
                                </Row>
                                <Row>
                                    <Col span = {20}>
                                        <Row>
                                            <Col span={5}><div className="text-white-title">DBD Register Number</div><Input className="report-input" value={item.obJectFuture.dbdRegisterNumber ? item.obJectFuture.dbdRegisterNumber : "ไม่มี"} /></Col>
                                            <Col span={5}><div className="text-white-title">ปีงบประมาณ</div><Input className="report-input" value={item.obJectFuture.yearOfBudget ? item.obJectFuture.yearOfBudget : "ไม่มี"} /></Col>
                                            <Col span={5}><div className="text-white-title">วัน/เดือน/ปี ที่รับลูกค้า</div><Input className="report-input" value={item.obJectFuture.fromDate ? item.obJectFuture.fromDate : "ไม่มี"} /></Col>
                                            <Col span={5}><div className="text-white-title">สถานะปัจจุบัน</div><Input className="report-input" value={item.status ? item.status : "ไม่มี"} /></Col>
                                            <Col span={4}><div className="text-white-title">Lead Time</div><Input className="report-input" value={countMonth ? countMonth || "-" : "ไม่มี"} /></Col>
                                        </Row>
                                        <Row>
                                            <Col span={5}><div className="text-white-title">วัตถุประสงค์ขอคำปรึกษาด้านการลงทุน</div><Input className="report-input" value={item.obJectFuture.isInvestmentAdvice ? "ใช่" : "ไม่ใช่"} /></Col>
                                            <Col span={5}><div className="text-white-title">วัตถุประสงค์เยี่ยมชมพื้นที่/สอบถามข้อมูลที่ดิน</div><Input className="report-input" value={item.obJectFuture.isVisitAreaLandInfo ? "ใช่" : "ไม่ใช่"} /></Col>
                                            <Col span={5}><div className="text-white-title">วัตถุประสงค์สอบถามอนุมัติ/อนุญาต</div><Input className="report-input" value={item.obJectFuture.isAskForApprove ? "ใช่" : "ไม่ใช่"} /></Col>
                                            <Col span={5}><div className="text-white-title">วัตถุประสงค์ในการติดต่ออื่นๆ</div><Input className="report-input" value={item.obJectFuture.otherPurposes ? item.obJectFuture.otherPurposes : "ไม่มี"} /></Col>
                                            <Col span={4}><div className="text-white-title">ประเภทการจัดตั้งบริษัท</div><Input className="report-input" value={item.companyTypeName ? item.companyTypeName || "-" : "ไม่มี"} /></Col>
                                        </Row>
                                        <Row>
                                            <Col span={24}><div className="text-white-title">ประเด็นติดต่อต่าง ๆ</div>
                                                <div  className="card bg-light shadow-sm" style={{marginLeft:0}}>
                                                    <div className="card-body card-scroll h-200px div_scroll" >
                                                        {Array.isArray(item.obJectFuture.topicList) && item.obJectFuture.topicList > 0 ? item.obJectFuture.topicList.map((sv, index) => (
                                                            <span key={index}>
                                                                - {sv.topicName === "อื่นๆ"
                                                                    ? - `${sv.topicName} : ${sv.topicOther}`
                                                                    : - sv.topicName || "-" }
                                                                <br />
                                                            </span>
                                                        )): "-"}
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={4}>
                                        <Image
                                            src={previewImageH}
                                            wrapperStyle={{
                                                width: "100%", 
                                                aspectRatio: "300 / 150", 
                                                overflow: "hidden",       
                                            }}
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "cover",
                                            }}
                                            preview={{ mask: null }}
                                        />
                                    </Col>
                                    {/* <Col span={4}><div className="text-white-title">ประเด็นติดต่อต่าง ๆ</div>
                                        <div  className="card bg-light shadow-sm" style={{marginLeft:0}}>
                                            <div className="card-body card-scroll h-200px div_scroll" >
                                                {Array.isArray(item.obJectFuture.topicList) && item.obJectFuture.topicList > 0 ? item.obJectFuture.topicList.map((sv, index) => (
                                                    <span key={index}>
                                                        - {sv.topicName === "อื่นๆ"
                                                            ? - `${sv.topicName} : ${sv.topicOther}`
                                                            : - sv.topicName || "-" }
                                                        <br />
                                                    </span>
                                                )): "-"}
                                            </div>
                                        </div>
                                    </Col> */}
                                </Row>
                                <Row>
                                    <Col span={24}><br/><div  className="text-white-head">ข้อมูลบริษัท</div><br/></Col>
                                </Row>
                                <Row>
                                    <Col span={4}><div className="text-white-title">ชื่อบริษัท (TH)</div><Input className="report-input" value={item.companyNameTh ? item.companyNameTh : "ไม่มี"} /></Col>
                                    <Col span={4}><div className="text-white-title">ชื่อบริษัท (EN)</div><Input className="report-input" value={item.companyNameEn ? item.companyNameEn : "ไม่มี"} /></Col>
                                    <Col span={8}><div className="text-white-title">ที่อยู่บริษัท</div><Input className="report-input" value={item.obJectFuture.address ? item.obJectFuture.address : "ไม่มี"} /></Col>
                                    <Col span={6}><div className="text-white-title">Website บริษัท</div><Input className="report-input" value={item.website ? item.website : "ไม่มี"} /></Col>
                                    <Col span={2}><div className="text-white-title">สัญชาติบริษัท</div><Input className="report-input"
                                        value={
                                            item?.obJectFuture?.nationalIds
                                            ? countries
                                                .filter(objItem => item.obJectFuture.nationalIds.includes(objItem.countryId))
                                                .map(objItem => objItem.countryNameTh)
                                                .join(", ")
                                            : "ไม่มี"
                                        }/>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={24}><br/>
                                        <div className="text-white-head">
                                            จำนวนรายชื่อสมาชิกทั้งหมด
                                            &nbsp;{item.obJectFuture?.futureCustomerMembers ? item.obJectFuture?.futureCustomerMembers.length : 0}&nbsp; คน<br/>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={24}>
                                        <Table style={{ padding: "30px 0px 30px 0px" }} dataSource={item.obJectFuture?.futureCustomerMembers ?? []} columns={columns} pagination={false}></Table>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={24}><br/><div  className="text-white-head">ข้อมูลอุตสาหกรรม</div><br/></Col>
                                </Row>
                                <Row>
                                    <Col span={4}><div className="text-white-title">อุตสาหกรรมปัจจุบัน</div><Input className="report-input" value={item.obJectFuture.currentIndustry ? item.obJectFuture.currentIndustry : "ไม่มี"} /></Col>
                                    <Col span={4}><div className="text-white-title">อุตสาหกรรมที่ต้องการดำเนินการในพื้นที่ กนอ.</div><Input className="report-input" value={item.obJectFuture.ieatIndusrty ? item.obJectFuture.ieatIndusrty : "ไม่มี"} /></Col>
                                    <Col span={4}><div className="text-white-title">ประเภทอุตสาหกรรม</div><Input className="report-input" 
                                        value={item?.obJectFuture?.industryTypeIds ? 
                                            dropDownIndustryType.filter(objItem => item.obJectFuture.industryTypeIds.includes(objItem.dataId))
                                            .map(objItem => objItem.dataDetailTh).join(", ")
                                            : "ไม่มี"} />
                                    </Col>
                                    <Col span={4}><div className="text-white-title">ประเภทพื้นที่ที่ลูกค้าต้องการ</div><Input className="report-input" 
                                        value={item.obJectFuture.areaTypeIds ? 
                                            dropDownAreaType.filter(objItem => item.obJectFuture.areaTypeIds.includes(objItem.dataId))
                                            .map(objItem => objItem.dataDetailTh).join(", ")
                                            : "ไม่มี"} />
                                    </Col>
                                    <Col span={4}><div className="text-white-title">เงินลงทุนธุรกิจ</div><Input className="report-input" value={item.obJectFuture.investmentAmount ? item.obJectFuture.investmentAmount : "ไม่มี"} /></Col>
                                </Row>
                                <Row>
                                    <Col span={4}><div className="text-white-title">ขนาดพื้นที่ที่ต้องการ (ไร่)</div><Input className="report-input" value={item.obJectFuture.areaSizeRai ? item.obJectFuture.areaSizeRai : "-"} /></Col>
                                    <Col span={4}><div className="text-white-title">ขนาดพื้นที่ที่ต้องการ (งาน)</div><Input className="report-input" value={item.obJectFuture.areaSizeNgan ? item.obJectFuture.areaSizeNgan : "-"} /></Col>
                                    <Col span={4}><div className="text-white-title">ขนาดพื้นที่ที่ต้องการ (วา)</div><Input className="report-input" value={item.obJectFuture.areaSizeWa ? item.obJectFuture.areaSizeWa : "-"} /></Col>
                                    <Col span={4}><div className="text-white-title">ขนาดโรงงานมาตรฐานที่ต้องการ (ตารางเมตร)</div><Input className="report-input" value={item.obJectFuture.areaSizeMeter ? item.obJectFuture.areaSizeMeter : "-"} /></Col>
                                    <Col span={4}><div className="text-white-title">ปริมาณการใช้น้ำต่อเดือน ลูกบาศก์เมตร (ลบ.ม.)</div><Input className="report-input" value={item.obJectFuture.waterConsumptionAmount ? item.obJectFuture.waterConsumptionAmount : "ไม่ใช่"} /></Col>
                                    <Col span={4}><div className="text-white-title">พื้นที่ที่ลูกค้าสนใจลงทุน</div><Input className="report-input" value={item.obJectFuture.areaSizeRecommend ? item.obJectFuture.areaSizeRecommend : "-"} /></Col>

                                </Row>
                                <Row>
                                    <Col span={4}><div className="text-white-title">ปริมาณการใช้ไฟฟ้า (กิโลวัตต์)</div><Input className="report-input" value={item.obJectFuture.kwAmount ? item.obJectFuture.kwAmount : "-"} /></Col>
                                    <Col span={4}><div className="text-white-title">ปริมาณน้ำ​เสีย ลูกบาศก์เมตร (ลบ.ม.)</div><Input className="report-input" value={item.obJectFuture.wasteWaterAmount ? item.obJectFuture.wasteWaterAmount : "-"} /></Col>
                                </Row>
                                <Row>
                                    <Col span={24}><br/><div  className="text-white-head">ข้อมูลเสียงของลูกค้า (VOC)</div><br/></Col>
                                </Row>
                                <Row>
                                    <Col span={12}>
                                        <br/><div  className="text-white-head">ด้านผลิตภัณฑ์และบริการ</div><br/>
                                            <div  className="card bg-light shadow-sm">
                                                <div className="card-body card-scroll h-200px div_scroll" >
                                                    1. ลูกค้ามีความต้องการ ด้านผลิตภัณฑ์และบริการ ของ กนอ. อย่างไร<br/>
                                                    {productRequirement ? 
                                                        dropDownproductRequirement.filter(objItem => productRequirement.includes(objItem.vocUniqueId))
                                                        .map(objItem => objItem.vocDetailTh).join("- ")
                                                        : "ไม่มี"}<br/>
                                                    2. ลูกค้ามีความคาดหวังที่นอกเหนือจากความต้องการ ด้านผลิตภัณฑ์และบริการ ของ กนอ. อย่างไร<br/>
                                                    {otherProductExpect ? 
                                                        dropDownotherProductExpect.filter(objItem => otherProductExpect.includes(objItem.vocUniqueId))
                                                        .map(objItem => objItem.vocDetailTh).join("- ")
                                                        : "ไม่มี"}<br/>
                                                    
                                                </div>
                                            </div>
                                    </Col>
                                    <Col span={12}>
                                        <br/><div  className="text-white-head">ด้านการสนับสนุนลูกค้า</div><br/>
                                            <div  className="card bg-light shadow-sm">
                                                <div className="card-body card-scroll h-200px div_scroll" >
                                                    1. ลูกค้ามีความคาดหวังที่นอกเหนือจากความต้องการ ด้านผลิตภัณฑ์และบริการ ของ กนอ. อย่างไร<br/>
                                                    {customerSupport ? 
                                                        dropDowncustomerSupport.filter(objItem => customerSupport.includes(objItem.vocUniqueId))
                                                        .map(objItem => objItem.vocDetailTh).join("- ")
                                                        : "ไม่มี"}<br/>
                                                    2. ลูกค้ามีความคาดหวังที่นอกเหนือจากความต้องการ ด้านผลิตภัณฑ์และบริการ ของ กนอ. อย่างไร<br/>
                                                    {otherSupportExpect ? 
                                                        dropDownotherSupportExpect.filter(objItem => otherSupportExpect.includes(objItem.vocUniqueId))
                                                        .map(objItem => objItem.vocDetailTh).join("- ")
                                                        : "ไม่มี"}<br/>
                                                </div>
                                            </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={12}>
                                        <br/><div  className="text-white-head">ด้านการทำธุรกรรม</div><br/>
                                            <div  className="card bg-light shadow-sm">
                                                <div className="card-body card-scroll h-200px div_scroll" >
                                                    1. ลูกค้ามีความต้องการ ด้านการทำธุรกรรม (อนุมัติอนุญาตสิทธิประโยชน์) ของ กนอ. อย่างไร<br/>
                                                    {businessRequire ? 
                                                        dropDownbusinessRequire.filter(objItem => businessRequire.includes(objItem.vocUniqueId))
                                                        .map(objItem => objItem.vocDetailTh).join("- ")
                                                        : "ไม่มี"}<br/>
                                                    2. ลูกค้ามีความ คาดหวังที่นอกเหนือจากความต้องการ ด้านสนับสนุนลูกค้า ของ กนอ. อย่างไร<br/>
                                                    {otherBusinessExpect ? 
                                                        dropDownotherBusinessExpect.filter(objItem => otherBusinessExpect.includes(objItem.vocUniqueId))
                                                        .map(objItem => objItem.vocDetailTh).join("- ")
                                                        : "ไม่มี"}<br/>
                                                </div>
                                            </div>
                                    </Col>
                                    <Col span={12}>
                                        <br/><div  className="text-white-head">ด้านการจัดการความสัมพันธ์ (CRM)</div><br/>
                                            <div  className="card bg-light shadow-sm">
                                                <div className="card-body card-scroll h-200px div_scroll" >
                                                    1. ลูกค้ามีความคาดหวังที่นอกเหนือจากความต้องการ ด้านผลิตภัณฑ์และบริการ ของ กนอ. อย่างไร<br/>
                                                    {customerExpact ? 
                                                        dropDowncustomerExpact.filter(objItem => customerExpact.includes(objItem.vocUniqueId))
                                                        .map(objItem => objItem.vocDetailTh).join("- ")
                                                        : "ไม่มี"}<br/>
                                                    2. Other VOC<br/>
                                                    {otherExpect ? otherExpect : "-" }
                                                    <br/>
                                                </div>
                                            </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={12}><br/><div  className="text-white-head">บันทึกพฤติกรรมลูกค้า</div><br/>
                                    <div  className="card bg-light shadow-sm">
                                        <div className="card-body card-scroll h-200px div_scroll" >
                                            บันทึกพฤติกรรมลูกค้า<br/>
                                            {item?.obJectFuture?.futureCustomerBehavior?.[0]?.channel?.length > 0 ? (
                                            <ul style={{ paddingLeft: 15 }}>
                                                {dataDetail.futureCustomerBehavior.length > 0 ? (
                                                <>
                                                    <Text>
                                                    {item.obJectFuture.futureCustomerBehavior[0].customerBehavior != ""
                                                        ? "- " + item.obJectFuture.futureCustomerBehavior[0].customerBehavior
                                                        : "-"}
                                                    </Text>
                                                </>
                                                ) : (
                                                <>
                                                    <Text>-</Text>
                                                </>
                                                )}
                                            </ul>
                                            ) : (
                                            <Text>-</Text>
                                            )}
                                            ช่องทางรู้จักกับทาง กนอ.<br/>
                                            {item?.obJectFuture?.futureCustomerBehavior?.[0]?.channel?.length > 0 ? (
                                            <ul style={{ paddingLeft: 15 }}>
                                                {dropDownKnowChannel
                                                .filter(channelItem =>
                                                    item.obJectFuture.futureCustomerBehavior[0].channel.includes(channelItem.dataId)
                                                )
                                                .map(channelItem => (
                                                    <li key={channelItem.dataId}>{channelItem.dataDetailTh}</li>
                                                ))}
                                            </ul>
                                            ) : (
                                            <Text>-</Text>
                                            )}
                                            ข้อเสนอแนะช่องทางการสื่อสารและ การให้บริการที่ลูกค้าใช้ในการติดต่อ<br/>
                                            {item?.obJectFuture?.futureCustomerBehavior?.[0]?.channel?.length > 0 ? (
                                            <ul style={{ paddingLeft: 15 }}>
                                                {dataDetail.futureCustomerBehavior.length > 0 ? (
                                                <>
                                                    <Text>
                                                    {item.obJectFuture.futureCustomerBehavior[0].suggestion != ""
                                                        ? "- " + item.obJectFuture.futureCustomerBehavior[0].suggestion
                                                        : "-"}
                                                    </Text>
                                                </>
                                                ) : (
                                                <>
                                                    <Text>-</Text>
                                                </>
                                                )}
                                            </ul>
                                            ) : (
                                            <Text>-</Text>
                                            )}
                                        </div>
                                    </div>
                                    </Col>
                                    <Col span={12}><br/>
                                        <div  className="text-white-head">สรุปการติดต่อรายครั้ง</div><br/>
                                            {item.obJectFuture.futureCustomerContacts.length > 0 
                                            ? (item.obJectFuture.futureCustomerContacts.map((objItem,idx)=>
                                                <Row>
                                                    <Col span={8}><div className="text-white-title">การติดต่อครั้งที่</div>
                                                        <Input className="report-input" value={idx+1} />
                                                    </Col>
                                                    <Col span={8}><div className="text-white-title">วันที่รับลูกค้า</div>
                                                        <Input className="report-input" value={objItem.contactDate ? objItem.contactDate : "-"} />
                                                    </Col>
                                                    <Col span={8}><div className="text-white-title">ชื่อเจ้าหน้าที่</div>
                                                        <Input className="report-input" value={objItem.officerName ? objItem.officerName : "-"} />
                                                    </Col>
                                                    <Col span={24}><div className="text-white-title">รายละเอียดการติดต่อ</div>
                                                    <div  className="card bg-light shadow-sm" style={{ marginTop: '5px' }}>
                                                        <div className="card-body card-scroll h-200px div_scroll" >
                                                            {objItem.detail}
                                                        </div>
                                                    </div>
                                                    <br/>
                                                    <div key={idx}>
                                                        <Button type="default" style={{  borderColor: "#7326a6" }} onClick={() => showImage(objItem.filePath,idx)} variant="filled">แสดงรูป</Button>
                                                        {console.log(objItem.fileName.endsWith(".pdf"))}
                                                        {modalIndex === idx && (
                                                            <Modal
                                                                title="แสดงรูปภาพ"
                                                                open={modalIndex !== null}
                                                                footer={null}
                                                                onCancel={() => setModalIndex(null)}
                                                                width={800}
                                                            >
                                                            {objItem.fileName.endsWith(".pdf")
                                                                ? <iframe src={`${previewPdf}#toolbar=0`} style={{ width: "100%", height: 500 }} />
                                                                : <img src={previewImage} style={{ width: "100%" }} alt="แสดงรูปภาพ" />
                                                                }
                                                            </Modal>
                                                            )
                                                        }
                                                    </div>
                                                    </Col>
                                                </Row>
                                            )):(
                                                <div  className="card bg-light shadow-sm">
                                                    <div className="card-body card-scroll h-200px div_scroll" >
                                                    </div>
                                            </div>
                                        )}
                                    </Col>
                                </Row>
                                </List.Item>
                            )}
                        />
                    </div>
                </Col>
                <Col span={24} align="right">
                    <Pagination
                    showSizeChanger
                    defaultCurrent={pageValues.page + 1 || 1}
                    total={pageValues.total || 1}
                    onChange={onPageChange}
                    pageSize={1}
                    pageSizeOptions={[1,10, 20, 50, 100]}
                    showTotal={(total) => `รวม ${total} รายการ`}
                    />
                </Col>
            </Row>
        </div>
    );
};

export default Content;
